import BaseContainer from "@base/container/BaseContainer";
import TweenMax, {Expo, Sine} from "gsap";
import * as PIXI from 'pixi.js';
import Power4 from "gsap";
import Linear from "gsap";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";

export default class BulletContainer extends BaseContainer {

  constructor(time, distance) {
    super()

    this.time = time
    this.distance = distance

    this.wrapper = new PIXI.Container()
    this.addChild(this.wrapper)

    this.bullet = new PIXI.Sprite(PIXI.Texture.from('bullet'))
    this.bullet.scale.set(0.4)
    this.bullet.anchor.set(0.5)
    this.bullet.rotation = Math.random() * Math.PI
    this.bullet.visible = true

    this.impact = new SpineAnimation('impact', () => {
      // this.impact.visible = false
    })

    this.impact.visible = false

    this.wrapper.addChild(this.bullet)
    this.wrapper.addChild(this.impact)
  }

  start() {
    this.wrapper.position.set(0, 0)

    this.bullet.visible = true
    this.bullet.alpha = 0;

    TweenMax.to(this.bullet, 0.1, { alpha:1 });

    TweenMax.to(this.bullet, this.time, {rotation: '+=9'})
    TweenMax.to(this.wrapper, this.time, {
      x: this.distance.x,
      y: this.distance.y,
      ease: 'none', onComplete: () => { this.stop() }
    })

    TweenMax.to(this, this.time - this.time/8, { onComplete: () => { this.impactIt() }})
  }

  impactIt() {
    TweenMax.to(this.bullet, 0.2, {alpha: 0})
    this.impact.visible = true
    this.impact.start(['impact'], [false])
  }

  stop() {
    this.bullet.alpha = 1
    this.bullet.visible = false
    TweenMax.killTweensOf(this)
    TweenMax.killTweensOf(this.wrapper)
  }

}
